<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Project Summary Report</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
    </v-toolbar>
    <div v-if="alertMsg">
      <v-alert
        v-if="error == 0 && statusCode == 200"
        :value="true"
        type="success"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
      <v-alert
        v-if="error == 1 && statusCode == 204"
        :value="true"
        type="info"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
      <v-alert
        v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
      <v-alert
        v-if="error == 1 && statusCode == 500"
        :value="true"
        type="error"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
    </div>
    <div v-if="checkTotal() < 1" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-data-table v-if="indexData.projects"
      :headers="headers"
      :items="indexData.projects.data"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      :loading="loading"
      class="elevation-1"
    >
      <v-progress-linear color="blue" indeterminate></v-progress-linear>
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.header.text }}
            </span>
          </template>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>

      <template v-if="checkTotal() > 0" v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.project_status_name }}</td>
        <td>{{ props.item.completion_percentage }}%</td>
        <td>{{ props.item.begin_date }}</td>
        <td>{{ props.item.end_date }}</td>
        <td>{{ props.item.number_of_response }}</td>
        
        <td>{{ props.item.project_type_name }}</td>
        <td>{{ props.item.details.substring(0, 30) }}</td>
        <td>
          {{
            props.item.total_pending_res +
            props.item.total_accepted_res +
            props.item.total_modified_res +
            props.item.total_canceled_res +
            props.item.total_rejected_res
          }}
        </td>
        <td>{{ props.item.total_pending_res }}</td>
        <td>{{ props.item.total_accepted_res }}</td>
        <td>{{ props.item.total_rejected_res }}</td>
        <td>{{ props.item.total_canceled_res }}</td>
        <td>{{ props.item.total_modified_res }}</td>
        <td>{{ props.item.total_budget_amount }}</td>
        <td>{{ props.item.budget_to_dasher / 10 }}</td>
        <td>{{ props.item.budget_to_dasher }}</td>
        <td>{{ props.item.budget_to_admin }}</td>
        <td>{{ props.item.budget_remains }}</td>
        <td>{{ props.item.created_by }}</td>
        <td class="justify-center layout px-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="checkItemReport(props.item.id)"
              >
                visibility
              </v-icon>
            </template>
            <span>view</span>
          </v-tooltip>
        </td>
      </template>
      <template v-else v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          {{ errorMsg }}
        </v-alert>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:pageText>
        Rows {{ indexData.projects.from }} - {{ indexData.projects.to }} of {{ indexData.projects.total }}
      </template>
    </v-data-table>
    <template v-if="indexData.projects">
     
      <div class="text-xs-center">
        <v-layout wrap>
          <v-flex xs1>
            <v-btn class="button" color="info" flat @click="download">Download</v-btn>
          </v-flex>
          <v-flex xs10 sm10 md10>
            <v-pagination right
            v-model="indexData.projects.current_page"
            :length="indexData.projects.last_page"
            @input="onPageChange">
            </v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </template>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    alertMsg: false,
    apiUrl: "project-summary-report",
    sl: 1,
    headers: [
      { text: "Project Id", align: "left", value: "id" },
      { text: "Project Name", align: "left", value: "name" },
      { text: "Project Created At", align: "left", value: "created_at" },
      {
        text: "Project Status",
        align: "left",
        sortable: false,
        value: "project_status_name",
      },
      {
        text: "Completion Percentage",
        align: "left",
        sortable: false,
        value: "completion_percentage",
      },
      { text: "Estimated Starting Time", value: "begin_date" },
      { text: "Project Ending Time", value: "end_date" },
      { text: "Total Response", value: "number_of_response" },
      { text: "Project Types", value: "project_type_name" },
      { text: "Project Details", value: "details" },
      { text: "Number of responses collected", value: "number_of_response" },
      { text: "Total Pending", value: "total_pending_res" },
      { text: "Total Accepted", value: "total_accepted_res" },
      { text: "Total Rejected", value: "total_rejected_res" },
      { text: "Total Canceled", value: "total_canceled_res" },
      { text: "Total Modified", value: "total_modified_res" },
      { text: "Total Budget(Tk)", value: "total_budget_amount" },
      { text: "Total Budget spent on Dashers(Tk)", value: "budget_to_dasher" },
      { text: "Total Coins given to Dashers", value: "budget_to_dasher" },
      {
        text: "Total Budget spent on Administration",
        value: "budget_to_admin",
      },
      { text: "Total Budget remainder", value: "budget_remains" },
      { text: "Project Created By", align: "left", value: "created_by" },
      { text: "Actions", align: "center", value: "name", sortable: false },
    ],
    loading: false,
    search: "",
   
    pagination: {
      descending: true,
      rowsPerPage:5,
      page: 1,
      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
    },
    rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
    editedIndex: -1,
    editedItem: {},
    rowsPerPage:5,
    defaultItem: {
       rowsPerPage:5,
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
  },

  watch: {
    pagination() {
      this.pagination.rowsPerPage;
      this.onPageChange();
    },
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("getPaginatedIndexData", ["project-summary-report",this.search, 1,this.pagination.rowsPerPage,]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    checkItemReport(projectId) {
      // this.$store.dispatch("getProjectReportDetails", [
      //   projectId,
      //   "client-view",
      //   "/",
      // ]);
      this.$router.push(`/${projectId}/project-report-details`);
    },

    download() {
        window.open(this.indexData.excelDownload);
    },

    checkTotal(){
      if(this.indexData.projects){
        return this.indexData.projects.total;
      }
      return 0;
      
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    onPageChange() {
      this.paginationMethod();
    },

    paginationMethod() {
      // console.log(this.search)
      this.loading = true;
      if (this.search) {
        this.$store.dispatch("getPaginatedIndexData", [
          "project-summary-report",
          this.search,
          this.indexData.projects.current_page,
          this.pagination.rowsPerPage,
        ]);
        this.loading = this.indexData.projects.data ? false : true;
      } else {
        this.$store.dispatch("getPaginatedIndexData", [
          "project-summary-report",
          this.search,
          this.indexData.projects.current_page,
          this.pagination.rowsPerPage,
        ]);
        this.loading = !this.indexData.error ? false : true;
      }
      this.dialog = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem

.imageResize
  width: auto
  height: auto
</style>
